/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Сервис управления настройками видеоконфига
 */

/**
 * Сервис управления настройками видеоконфига
 */
export class VideoChannelServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод редактирования единичной сущности VideoChannel по ключу
   */
  EditVideoChannel = (req: Pick<EditVideoChannelRequestDto, "updateMask"> & { data: Pick<VideoChannelRequestDto, "chanelNumber"> & fm.RequireAtLeastOne<Omit<VideoChannelRequestDto, "chanelNumber">> }, init?: RequestInit): Promise<EditVideoChannelResponseDto> => {
    return fm.request<Pick<EditVideoChannelRequestDto, "updateMask"> & { data: Pick<VideoChannelRequestDto, "chanelNumber"> & fm.RequireAtLeastOne<Omit<VideoChannelRequestDto, "chanelNumber">> }, EditVideoChannelResponseDto>(`${this.host}/device/api/v1/video_channel/${encodeURIComponent(req.data.chanelNumber)}`, { ...init, method: "PATCH", body: JSON.stringify(req.data, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка сущностей VideoChannel по фильтру
   */
  GetVideoChannelList = (req?: GetVideoChannelListRequestDto, init?: RequestInit): Promise<GetVideoChannelListResponseDto> => {
    return fm.request<GetVideoChannelListRequestDto, GetVideoChannelListResponseDto>(`${this.host}/device/api/v1/video_channel/list${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Режим Flow control mode
 */
export enum VideoChannelFlowControlModeType {
  /**
   * Значение не указано
   */
  FLOW_CONTROL_MODE_TYPE_UNKNOWN = "FLOW_CONTROL_MODE_TYPE_UNKNOWN",
  /**
   * Режим VBR
   */
  VBR = "VBR",
  /**
   * Режим CBR
   */
  CBR = "CBR",
  /**
   * Режим CVBR
   */
  CVBR = "CVBR",
  /**
   * Режим AVBR
   */
  AVBR = "AVBR",
  /**
   * Режим FIXP
   */
  FIXP = "FIXP",
  /**
   * Режим QVBR
   */
  QVBR = "QVBR",
}
/**
 * Режим Flow control mode
 */
export type VideoChannelFlowControlModeTypeResponseEnum = keyof typeof VideoChannelFlowControlModeType
/**
 * Режим Flow control mode
 */
export type VideoChannelFlowControlModeTypeRequestEnum = Exclude<VideoChannelFlowControlModeTypeResponseEnum, "FLOW_CONTROL_MODE_TYPE_UNKNOWN">;

/**
 * Формат видео
 */
export enum VideoChannelFormatType {
  /**
   * Значение не указано
   */
  FORMAT_TYPE_UNKNOWN = "FORMAT_TYPE_UNKNOWN",
  /**
   * Формат mjpeg
   */
  MPEG = "MPEG",
  /**
   * Формат h.264
   */
  H264 = "H264",
  /**
   * Формат h.264+
   */
  H264_PLUS = "H264_PLUS",
  /**
   * Формат h.265
   */
  H265 = "H265",
}
/**
 * Формат видео
 */
export type VideoChannelFormatTypeResponseEnum = keyof typeof VideoChannelFormatType
/**
 * Формат видео
 */
export type VideoChannelFormatTypeRequestEnum = Exclude<VideoChannelFormatTypeResponseEnum, "FORMAT_TYPE_UNKNOWN">;

/**
 * Профиль
 */
export enum VideoChannelProfileType {
  /**
   * Значение не указано
   */
  PROFILE_TYPE_UNKNOWN = "PROFILE_TYPE_UNKNOWN",
  /**
   * Высокий
   */
  PROFILE_HIGH = "PROFILE_HIGH",
  /**
   * Основной
   */
  PROFILE_MAIN = "PROFILE_MAIN",
  /**
   * Базовый
   */
  PROFILE_BASE = "PROFILE_BASE",
}
/**
 * Профиль
 */
export type VideoChannelProfileTypeResponseEnum = keyof typeof VideoChannelProfileType
/**
 * Профиль
 */
export type VideoChannelProfileTypeRequestEnum = Exclude<VideoChannelProfileTypeResponseEnum, "PROFILE_TYPE_UNKNOWN">;

/**
 * Тип разрешения видео
 */
export enum VideoChannelResolutionType {
  /**
   * Значение не указано
   */
  RESOLUTION_TYPE_UNKNOWN = "RESOLUTION_TYPE_UNKNOWN",
  /**
   * Тип разрешения 2K 2560*1440
   */
  R2K = "R2K",
  /**
   * Тип разрешения FULLHD 1920*1080
   */
  FULLHD = "FULLHD",
  /**
   * Тип разрешения HD 1280*720
   */
  HD = "HD",
  /**
   * Тип разрешения SD 720*576
   */
  SD = "SD",
  /**
   * Тип разрешения 4CIF 704*576
   */
  R4CIF = "R4CIF",
  /**
   * Тип разрешения VGA 640*480
   */
  VGA = "VGA",
}
/**
 * Тип разрешения видео
 */
export type VideoChannelResolutionTypeResponseEnum = keyof typeof VideoChannelResolutionType
/**
 * Тип разрешения видео
 */
export type VideoChannelResolutionTypeRequestEnum = Exclude<VideoChannelResolutionTypeResponseEnum, "RESOLUTION_TYPE_UNKNOWN">;

/**
 * Запрос редактирования единичной сущности VideoChannel по ключу
 */
export type EditVideoChannelRequestDto = {
  /**
   * Настройки видеоконфига
   */
  data: VideoChannelRequestDto
  /**
   * Маска полей обновления
   */
  updateMask?: string | null
}
/**
 * Ответ на запрос редактирования единичной сущности VideoChannel по ключу
 */
export type EditVideoChannelResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки видеоконфига
   */
  readonly data: VideoChannelResponseDto
  /**
   * Ошибка
   */
  readonly error: EditVideoChannelResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type EditVideoChannelResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type EditVideoChannelResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения списка сущностей VideoChannel по фильтру
 */
export type GetVideoChannelListRequestDto = {
}
/**
 * Ответ на запрос получения списка сущностей VideoChannel по фильтру
 */
export type GetVideoChannelListResponseDto = {
  /**
   * Список VideoChannel
   */
  data: VideoChannelResponseDto[]
}
/**
 * Настройки видеоконфига
 */
export type VideoChannelRequestDto = {
  /**
   * Порядковый номер видеоконфига
   */
  chanelNumber: number
  /**
   * Флаг активности
   */
  isEnabled: boolean
  /**
   * Тип разрешения видео
   */
  resolutionType?: VideoChannelResolutionTypeRequestEnum | "RESOLUTION_TYPE_UNKNOWN"
  /**
   * Формат видео
   */
  formatType?: VideoChannelFormatTypeRequestEnum | "FORMAT_TYPE_UNKNOWN"
  /**
   * Профиль
   */
  profileType?: VideoChannelProfileTypeRequestEnum | "PROFILE_TYPE_UNKNOWN"
  /**
   * Частота кадров
   */
  fps?: number
  /**
   * Периодичность опорного кадра
   */
  gop?: number
  /**
   * Режим FlowControlModeType
   */
  flowControlModeType?: VideoChannelFlowControlModeTypeRequestEnum | "FLOW_CONTROL_MODE_TYPE_UNKNOWN"
  /**
   * Целевая скорость потока, килобит
   */
  biterate?: number
  /**
   * Флаг rtsp_audio
   */
  isRtspAudio?: boolean
  /**
   * Флаг use for sip
   */
  isUsedForSip?: boolean
}
/**
 * Настройки видеоконфига
 */
export type VideoChannelResponseDto = {
  /**
   * Порядковый номер видеоконфига
   */
  chanelNumber: number
  /**
   * Флаг активности
   */
  isEnabled: boolean
  /**
   * Тип разрешения видео
   */
  resolutionType: VideoChannelResolutionTypeResponseEnum
  /**
   * Формат видео
   */
  formatType: VideoChannelFormatTypeResponseEnum
  /**
   * Профиль
   */
  profileType: VideoChannelProfileTypeResponseEnum
  /**
   * Частота кадров
   */
  fps: number
  /**
   * Периодичность опорного кадра
   */
  gop: number
  /**
   * Режим FlowControlModeType
   */
  flowControlModeType: VideoChannelFlowControlModeTypeResponseEnum
  /**
   * Целевая скорость потока, килобит
   */
  biterate: number
  /**
   * Флаг rtsp_audio
   */
  isRtspAudio: boolean
  /**
   * Флаг use for sip
   */
  isUsedForSip: boolean
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос редактирования единичной сущности VideoChannel по ключу
   */
  "EditVideoChannelRequest": {
    "kind": "class",
    "text": "Запрос редактирования единичной сущности VideoChannel по ключу",
    "fields": {
      /**
       * Настройки видеоконфига
       */
      "data": {
        "type": "VideoChannel",
        "text": "Настройки видеоконфига",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Маска полей обновления
       */
      "updateMask": {
        "type": "google.protobuf.FieldMask",
        "text": "Маска полей обновления",
      },
    },
  },
  /**
   * Ответ на запрос редактирования единичной сущности VideoChannel по ключу
   */
  "EditVideoChannelResponse": {
    "kind": "class",
    "text": "Ответ на запрос редактирования единичной сущности VideoChannel по ключу",
    "fields": {
      /**
       * Настройки видеоконфига
       */
      "data": {
        "type": "VideoChannel",
        "text": "Настройки видеоконфига",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "EditVideoChannelResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "EditVideoChannelResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения списка сущностей VideoChannel по фильтру
   */
  "GetVideoChannelListRequest": {
    "kind": "class",
    "text": "Запрос получения списка сущностей VideoChannel по фильтру",
  },
  /**
   * Ответ на запрос получения списка сущностей VideoChannel по фильтру
   */
  "GetVideoChannelListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка сущностей VideoChannel по фильтру",
    "fields": {
      /**
       * Список VideoChannel
       */
      "data": {
        "type": "VideoChannel",
        "text": "Список VideoChannel",
      },
    },
  },
  /**
   * Настройки видеоконфига
   */
  "VideoChannel": {
    "kind": "class",
    "text": "Настройки видеоконфига",
    "fields": {
      /**
       * Порядковый номер видеоконфига
       */
      "chanelNumber": {
        "type": "int32",
        "text": "Порядковый номер видеоконфига",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Флаг активности
       */
      "isEnabled": {
        "type": "bool",
        "text": "Флаг активности",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип разрешения видео
       */
      "resolutionType": {
        "type": "VideoChannel.ResolutionType",
        "text": "Тип разрешения видео",
      },
      /**
       * Формат видео
       */
      "formatType": {
        "type": "VideoChannel.FormatType",
        "text": "Формат видео",
      },
      /**
       * Профиль
       */
      "profileType": {
        "type": "VideoChannel.ProfileType",
        "text": "Профиль",
      },
      /**
       * Частота кадров
       */
      "fps": {
        "type": "int32",
        "text": "Частота кадров",
      },
      /**
       * Периодичность опорного кадра
       */
      "gop": {
        "type": "int32",
        "text": "Периодичность опорного кадра",
      },
      /**
       * Режим FlowControlModeType
       */
      "flowControlModeType": {
        "type": "VideoChannel.FlowControlModeType",
        "text": "Режим FlowControlModeType",
      },
      /**
       * Целевая скорость потока, килобит
       */
      "biterate": {
        "type": "int32",
        "text": "Целевая скорость потока, килобит",
      },
      /**
       * Флаг rtsp_audio
       */
      "isRtspAudio": {
        "type": "bool",
        "text": "Флаг rtsp_audio",
      },
      /**
       * Флаг use for sip
       */
      "isUsedForSip": {
        "type": "bool",
        "text": "Флаг use for sip",
      },
    },
  },
  /**
   * Режим Flow control mode
   */
  "VideoChannel.FlowControlModeType": {
    "kind": "enum",
    "text": "Режим Flow control mode",
    "values": {
      /**
       * Значение не указано
       */
      "FLOW_CONTROL_MODE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Режим VBR
       */
      "VBR": {
        "i": 1,
        "text": "Режим VBR",
      },
      /**
       * Режим CBR
       */
      "CBR": {
        "i": 2,
        "text": "Режим CBR",
      },
      /**
       * Режим CVBR
       */
      "CVBR": {
        "i": 3,
        "text": "Режим CVBR",
      },
      /**
       * Режим AVBR
       */
      "AVBR": {
        "i": 4,
        "text": "Режим AVBR",
      },
      /**
       * Режим FIXP
       */
      "FIXP": {
        "i": 5,
        "text": "Режим FIXP",
      },
      /**
       * Режим QVBR
       */
      "QVBR": {
        "i": 6,
        "text": "Режим QVBR",
      },
    },
  },
  /**
   * Формат видео
   */
  "VideoChannel.FormatType": {
    "kind": "enum",
    "text": "Формат видео",
    "values": {
      /**
       * Значение не указано
       */
      "FORMAT_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Формат mjpeg
       */
      "MPEG": {
        "i": 1,
        "text": "Формат mjpeg",
      },
      /**
       * Формат h.264
       */
      "H264": {
        "i": 2,
        "text": "Формат h.264",
      },
      /**
       * Формат h.264+
       */
      "H264_PLUS": {
        "i": 3,
        "text": "Формат h.264+",
      },
      /**
       * Формат h.265
       */
      "H265": {
        "i": 4,
        "text": "Формат h.265",
      },
    },
  },
  /**
   * Профиль
   */
  "VideoChannel.ProfileType": {
    "kind": "enum",
    "text": "Профиль",
    "values": {
      /**
       * Значение не указано
       */
      "PROFILE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Высокий
       */
      "PROFILE_HIGH": {
        "i": 1,
        "text": "Высокий",
      },
      /**
       * Основной
       */
      "PROFILE_MAIN": {
        "i": 2,
        "text": "Основной",
      },
      /**
       * Базовый
       */
      "PROFILE_BASE": {
        "i": 3,
        "text": "Базовый",
      },
    },
  },
  /**
   * Тип разрешения видео
   */
  "VideoChannel.ResolutionType": {
    "kind": "enum",
    "text": "Тип разрешения видео",
    "values": {
      /**
       * Значение не указано
       */
      "RESOLUTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Тип разрешения 2K 2560*1440
       */
      "R2K": {
        "i": 1,
        "text": "Тип разрешения 2K 2560*1440",
      },
      /**
       * Тип разрешения FULLHD 1920*1080
       */
      "FULLHD": {
        "i": 2,
        "text": "Тип разрешения FULLHD 1920*1080",
      },
      /**
       * Тип разрешения HD 1280*720
       */
      "HD": {
        "i": 3,
        "text": "Тип разрешения HD 1280*720",
      },
      /**
       * Тип разрешения SD 720*576
       */
      "SD": {
        "i": 4,
        "text": "Тип разрешения SD 720*576",
      },
      /**
       * Тип разрешения 4CIF 704*576
       */
      "R4CIF": {
        "i": 5,
        "text": "Тип разрешения 4CIF 704*576",
      },
      /**
       * Тип разрешения VGA 640*480
       */
      "VGA": {
        "i": 6,
        "text": "Тип разрешения VGA 640*480",
      },
    },
  },
}